import React, { useState } from 'react'
import {
    Description,
    Download,
    Visibility
} from '@mui/icons-material';
import parse from "html-react-parser";
import { Col, Button, Card, Badge, Modal } from 'react-bootstrap';
import ERPUtils from '../../helper/Utils';



const JobCard = ({ key, ad, jobAdvertisements, width, applyHandler }) => {
    const [isTextType, setIsTextType] = useState()
    const [content, setContent] = useState()
    const [fullImage, setFullImage] = useState()
    const [isShowImage, setIsShowImage] = useState(false)

    const showImageHandler = (url, text, advertisementContent) => {
        if (!text) {
            setFullImage(url)
            setContent("")
        } else {
            setFullImage("")
            setContent(parse(advertisementContent) || "")
        }
        setIsTextType(text)
        setIsShowImage(true)
    }




    const isExtensionCheck = (extension) => {
        if (extension === ".jpg" || extension === ".png" || extension === ".jpeg") {
            return true;
        } else if (extension === ".pdf" || extension === ".docx" || extension === ".doc") {
            return false;
        } else {
            return true;
        }
    }

    const isCheckBoth = !ERPUtils.isNullorWhiteSpace(ad.advertisementContent) && !ERPUtils.isNullorWhiteSpace(ad.empApplnAdvertisementImages)
    const isCheckExtension = isExtensionCheck(ad.empApplnAdvertisementImages[0]?.extension)
    const imageUrl = ad.empApplnAdvertisementImages[0]?.url
    const isText = !ERPUtils.isNullorWhiteSpace(ad?.advertisementContent)
    return (
        <>
            {!ad.isCommonAdvertisement ? (
                <Col md={jobAdvertisements.length < 2 ? 12 : width} lg={jobAdvertisements.length < 2 ? 12 : width} className="mb-4 d-flex px-2">
                    <Card className="w-100 hover-card shadow p-2" style={{ borderRadius: "10px", cursor: "auto", width: "%" }}>
                        {/* Media Header */}
                        {!isCheckBoth ? (
                            <>
                                {!isText ? (
                                    <div className="position-relative" style={{ height: '300px', backgroundColor: '#f8f9fa', cursor: "pointer" }}>
                                        {!isCheckExtension ? (
                                            <div
                                                className="w-100 d-flex flex-column align-items-center justify-content-center cursor-pointer overflowY-auto"
                                                onClick={() => window.open(imageUrl, '_blank')}
                                                style={{ height: "300px" }}
                                            >
                                                {ERPUtils.isNullorWhiteSpace(imageUrl) ? (
                                                    <>
                                                        <Description style={{ fontSize: 48 }} className="text-navy opacity-50 mb-2" />
                                                        <span className="small fw-bold text-secondary text-uppercase">PDF Document</span>
                                                        <Badge bg="light" text="dark" className="mt-2 border">Click to View</Badge>
                                                    </>
                                                ) : (
                                                    <iframe
                                                        src={`https://docs.google.com/gview?embedded=true&url=${imageUrl}`}
                                                        style={{
                                                            position: "absolute",
                                                            top: 2,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            borderRadius: "10px",
                                                            border: "none",
                                                            transformOrigin: "top left",
                                                        }}
                                                        title={ad?.title}
                                                    />
                                                )}

                                            </div>
                                        ) : (
                                            <img
                                                src={imageUrl}
                                                alt={ad.title}
                                                onClick={() => showImageHandler(imageUrl)}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    border: "1px solid black",
                                                    objectFit: "cover",
                                                    cursor: "pointer"
                                                }}
                                            />

                                        )}
                                    </div>
                                ) : (
                                    <>
                                        <div className="border p-2 shadow-sm" style={{ maxHeight: "609px", overflow: "auto" }}>
                                            {ad.advertisementContent?.length > 0 && parse(ad.advertisementContent)}
                                        </div>
                                    </>
                                )}
                                <Card.Body className="d-flex flex-column p-3 p-md-4">
                                    <Card.Title className="fw-bold mb-2 text-navy">{ad?.title || ""}</Card.Title>
                                    {!ERPUtils.isNullorWhiteSpace(ad.advertisementNo) && (
                                        <div className="mt-2 mb-2">
                                            Job Advertisement Code: <span style={{ color: '#0b3b66' }}>{ad.advertisementNo || null}</span>
                                        </div>
                                    )}


                                    <div className="d-flex gap-2 mt-3">
                                        {!isCheckExtension ? (
                                            <Button
                                                variant="light"
                                                href={`https://docs.google.com/gview?embedded=true&url=${imageUrl}`}
                                                target="_blank"
                                                className="p-2 d-flex align-items-center justify-content-center gap-2 border text-white view-hover"
                                            >
                                                <Download style={{ fontSize: 16 }} />
                                                View/Download
                                            </Button>
                                        ) : (
                                            <Button variant="outline-light"
                                                onClick={() => showImageHandler(imageUrl, isText, ad?.advertisementContent)}
                                                className="p-2 d-flex align-items-center justify-content-center gap-2 rounded-1 text-white view-hover">
                                                <Visibility style={{ fontSize: 16 }} />
                                                View
                                            </Button>
                                        )}
                                        <Button
                                            variant='outline-warning'
                                            onClick={() => applyHandler(ad.advertisementNo)}
                                            // onClick={() => navigate(`/ApplicationForm/${ad.advertisementNo}`)}
                                            className="shadow-sm"
                                        >
                                            Apply Now
                                        </Button>
                                    </div>
                                </Card.Body>
                            </>
                        ) : (
                            <>
                                {/* CASE: BOTH TEXT AND IMAGE/PDF EXIST */}
                                {/* 1. Display Image/PDF Header */}
                                <div className="position-relative" style={{ height: '300px', backgroundColor: '#f8f9fa', cursor: "pointer" }}>
                                    {!isCheckExtension ? (
                                        <div
                                            className="w-100 d-flex flex-column align-items-center justify-content-center"
                                            style={{ height: "300px" }}
                                            onClick={() => window.open(imageUrl, '_blank')}
                                        >
                                            {ERPUtils.isNullorWhiteSpace(imageUrl) ? (
                                                <>
                                                    <Description style={{ fontSize: 48 }} className="text-navy opacity-50 mb-2" />
                                                    <span className="small fw-bold text-secondary text-uppercase">PDF Document</span>
                                                    <Badge bg="light" text="dark" className="mt-2 border">Click to View</Badge>
                                                </>
                                            ) : (
                                                <iframe
                                                    // src={imageUrl}
                                                    src={`https://docs.google.com/gview?embedded=true&url=${imageUrl}`}
                                                    style={{
                                                        position: "absolute",
                                                        top: 2,
                                                        left: 0,
                                                        overflow: "auto",
                                                        border: "1px solid groove",
                                                        borderRadius: "10px",
                                                        width: "100%",
                                                        background: "",
                                                        height: "100%",
                                                        transformOrigin: "top left",
                                                        // pointerEvents: "none"
                                                    }}
                                                    title={ad?.title}
                                                />
                                            )}
                                        </div>
                                    ) : (
                                        <img
                                            src={imageUrl}
                                            alt={ad.title}
                                            onClick={() => showImageHandler(imageUrl)}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                border: "1px solid black",
                                                objectFit: "cover",
                                                cursor: "pointer"
                                            }}
                                        />
                                    )}
                                </div>

                                {/* 2. Display Body with Title, Text Content, and Buttons */}
                                {!ERPUtils.isNullorWhiteSpace(ad.advertisementContent) && (
                                    <div className=" p-2 shadow-sm border mt-2" style={{ maxHeight: "300px", overflow: "auto" }}>
                                        {ad.advertisementContent?.length > 0 && parse(ad.advertisementContent)}
                                    </div>
                                )}
                                <Card.Body className="d-flex flex-column">
                                    <Card.Title className="fw-bold mb-2 text-navy">{ad?.title || ""}</Card.Title>
                                    {!ERPUtils.isNullorWhiteSpace(ad.advertisementNo) && (
                                        <div className="mt-2 mb-2">
                                            Job Advertisement Code: <span style={{ color: '#0b3b66' }}>{ad.advertisementNo || null}</span>
                                        </div>
                                    )}

                                    {/* Render the Text Content */}

                                    <div className="d-flex gap-2 mt-3">
                                        {/* View Button for the Image/PDF */}
                                        <Button
                                            variant="light"
                                            onClick={() => {
                                                isCheckExtension ? showImageHandler(imageUrl) : window.open(
                                                    `https://docs.google.com/gview?embedded=true&url=${imageUrl}`,
                                                    "_blank",
                                                    "noopener,noreferrer"
                                                )
                                            }}
                                            className="p-2 d-flex align-items-center justify-content-center gap-2 border text-white view-hover"
                                        >
                                            {!isCheckExtension && !isText ? <Download style={{ fontSize: 16 }} /> : <Visibility style={{ fontSize: 16 }} />}
                                            {!isCheckExtension && !isText ? "View/Download" : "View"}
                                        </Button>

                                        <Button
                                            variant='outline-warning'
                                            onClick={() => applyHandler(ad.advertisementNo)}
                                            // onClick={() => navigate(`/ApplicationForm/${ad.advertisementNo}`)}
                                            className="shadow-sm aply-hover"
                                        >
                                            Apply Now
                                        </Button>
                                    </div>
                                </Card.Body>
                            </>
                        )}
                    </Card>
                </Col >
            ) : <Col md={12} lg={12} className="mb-4 d-flex px-2">
                <Card className="w-100 hover-card overflow-hidden shadow p-2" style={{ borderRadius: "10px", cursor: "auto" }}>
                    <div className='p-2 border shadow-sm text-center border-radius-4 text-white'
                        style={{ background: " #0a4275", borderRadius: "5px", margin: "-10px -10px -10px" }}>
                        <h3 ><strong>Common Advertisement</strong></h3>
                    </div>
                    <Card.Body>
                        {parse(ad.advertisementContent)}
                        <div className="d-flex gap-2 mt-3">
                            <Button
                                variant='outline-warning'
                                onClick={() => applyHandler()}
                                className="shadow-sm"
                            >
                                Apply Now
                            </Button>
                        </div>
                    </Card.Body>
                </Card>
            </Col>
            }
            <Modal
                show={isShowImage}
                onHide={() => setIsShowImage(false)}
                size='xl'
                scrollable
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {isTextType ? "Job Advertisement" : "View Full Image"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!isTextType ? (
                        <img
                            src={fullImage}
                            alt="titei"
                            // onClick={() => showImageHandler(ad.url)}
                            style={{
                                width: "100%",
                                border: "1px solid black",
                                objectFit: "cover",
                                cursor: "pointer"
                            }}
                        />
                    ) : (
                        <div>
                            {content}
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
};

export default JobCard